export default __webpack_public_path__ + "static/media/clock-blue.9810ced1.svg";